<template>
  <div class="row">
    <div class="col-md-3" v-for="card in cards" :key="card.label">
      <div class="panel panel-default">
        <div class="panel-body text-center">
          <h4 class="text-muted">
            {{ card.label }}
            <CalculationTooltip :text="card.tooltip" />
          </h4>
          <p class="h2">{{ card.value }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalculationTooltip from '../../scheduling-dashboard/components/CalculationTooltip.vue';
import { inDollars } from '../../../../DriveScout/Billing/Teller';

export default {
  name: 'EcommerceSummaryCards',
  components: { CalculationTooltip },
  props: {
    summary: { type: Object, required: true }
  },
  computed: {
    cards() {
      if (!this.summary) return [];
      return [
        {
          label: 'Revenue',
          value: inDollars(this.summary.total_revenue),
          tooltip: 'Total revenue from completed orders in the selected date range.'
        },
        {
          label: 'Orders',
          value: Number(this.summary.total_orders).toLocaleString(),
          tooltip: 'Count of completed orders in the selected date range.'
        },
        {
          label: 'Avg Order Value',
          value: inDollars(this.summary.average_order_value),
          tooltip: 'Total revenue divided by total orders.'
        },
        {
          label: 'Products Sold',
          value: Number(this.summary.total_products_sold).toLocaleString(),
          tooltip: 'Total number of product units sold across all completed orders.'
        }
      ];
    }
  }
};
</script>
